import React, { type ReactNode } from 'react';
import type { ActionCreator } from 'redux';
import { connect } from 'react-redux';

import { actions } from '../../../state/filterActions';
import { fetchResults } from '../../../state/resultActions';

import type { OverrideValues, PaleState } from '../../../interfaces';
import { type CheckboxDispatchProps, CheckboxFilter, type CheckboxStateProps } from './CheckboxFilter';
import { SupplierLogo } from '../../resultList/images/SupplierLogo';

export const mapStateToProps = (state: PaleState): CheckboxStateProps => {
    const displayValues: Record<string, ReactNode> = {};
    state.results.facets.nonCharterSuppliers.forEach((supplier) => {
        displayValues[supplier.value] = <SupplierLogo supplier={supplier.value} className="u-valign-middle u-mr4" />;

        return displayValues[supplier.value];
    });
    return {
        id: 'NonCharterSupplierFilter',
        label: 'Fly + Hotell',
        facetList: state.results.facets.nonCharterSuppliers,
        displayValues: displayValues,
        checkboxValues: state.filters.suppliers,
    };
};

export const mapDispatchToProps: OverrideValues<CheckboxDispatchProps, ActionCreator<unknown>> = {
    checkBoxClick: actions.filterCheckboxSupplier,
    fetchResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckboxFilter);
